import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/warenlisten/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="GoodList"
      returnRoute="/auswahlfelder/goodList"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const GoodListRoute = Route;
